<script>
    import { get } from 'lodash-es'
    import { error, fetching, kyc, numberConfirmed, payment } from '$lib/stores'
    import LoadingSpinner from '$lib/Components/LoadingSpinner.svelte'
    import { isFinal } from '$lib/utilities/statusCodes'
    import { browser } from '$app/environment'
    import { navigating } from '$app/stores'
    import Kyc from '$lib/Components/Kyc/Kyc.svelte'
    import { fade } from 'svelte/transition'
    /**
     * @typedef {Object} Props
     * @property {import('svelte').Snippet} [children]
     */

    /** @type {Props} */
    let { children } = $props()

    let loading = $derived(get($fetching, `payment.fetching`, true))

    let poller = $state()

    $effect(() => {
        if (browser) {
            // Clear existing poller if payment is final or there's an error
            if (poller && (isFinal($payment.status) || $error)) {
                clearInterval(poller)
                poller = null
            }

            // Start new poller if number is confirmed and no poller exists
            if (!poller && $numberConfirmed && !isFinal($payment.status) && !$error) {
                poller = setInterval(async () => {
                    if (!$fetching.poll?.fetching && !isFinal($payment.status) && !$error) {
                        fetching.startFetching('poll')
                        await payment.doPoll()
                        fetching.cancelFetching('poll')
                    }
                }, 2_000)
            }
        }
    })
</script>

{#if loading || $navigating}
    <LoadingSpinner />
{:else if $kyc.required && !$kyc.completed}
    <Kyc />
{:else}
    <div in:fade={{ duration: 150 }}>
        {@render children?.()}
    </div>
{/if}
